import React, { useState, useEffect } from "react";
import { Card, Space, Tag, Select, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const MetaCard = ({ metadata, onUpdateMetadata, onDeleteMetadata }) => {
  const [availableGenres, setAvailableGenres] = useState([]);
  const [genreMap, setGenreMap] = useState({});

  useEffect(() => {
    const fetchAvailableGenres = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/genre/get-all`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setAvailableGenres(
          data.map((genre) => ({ name: genre.name, id: genre._id }))
        ); // Store both name and ID
        // Create a map of genre name to ID for easier lookup
        const genreMap = {};
        data.forEach((genre) => {
          genreMap[genre.name] = genre._id;
        });
        setGenreMap(genreMap);
      } catch (error) {
        console.error("Error fetching available genres:", error);
      }
    };

    fetchAvailableGenres();
  }, []);

  if (!metadata) {
    return <div>Không có dữ liệu Meta</div>;
  }

  const { name, id, genres } = metadata;

  const handleAddGenre = async (genreNameToAdd) => {
    try {
      const genreIdToAdd = genreMap[genreNameToAdd]; // Look up the ID from the map
      if (!genreIdToAdd) {
        console.warn(`Genre ID not found for ${genreNameToAdd}`);
        return; // Or handle the error appropriately
      }

      const updatedGenreIds = [
        ...genres.map((genreName) => genreMap[genreName]),
        genreIdToAdd,
      ]; // Get IDs of existing genres and add new one
      await onUpdateMetadata(id, { genresIncluding: updatedGenreIds });
    } catch (error) {
      console.error("Error adding genre:", error);
    }
  };

  const handleDeleteGenre = async (genreNameToDelete) => {
    try {
      const genreIdToDelete = genreMap[genreNameToDelete];
      if (!genreIdToDelete) {
        console.warn(`Genre ID not found for ${genreNameToDelete}`);
        return; // Or handle the error appropriately
      }
      const updatedGenreIds = genres
        .map((genreName) => genreMap[genreName])
        .filter((genreId) => genreId !== genreIdToDelete);

      await onUpdateMetadata(id, { genresIncluding: updatedGenreIds });
    } catch (error) {
      console.error("Error deleting genre:", error);
    }
  };

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {name || "Không có tên"}
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDeleteMetadata(id)}
          />
        </div>
      }
    >
      <Space style={{ display: "flex", flexWrap: "wrap", marginBottom: "8px" }}>
        {genres &&
          genres.map((genreName) => (
            <Tag
              key={genreName}
              closable
              onClose={() => handleDeleteGenre(genreName)}
            >
              {genreName}
            </Tag>
          ))}
        <Select
          placeholder="Add Genre"
          style={{ width: "100%" }}
          onChange={handleAddGenre}
          options={availableGenres
            .filter((genre) => !genres?.includes(genre.name))
            .map((genre) => ({ value: genre.name, label: genre.name }))}
        />
      </Space>
    </Card>
  );
};

export default MetaCard;
